<template src='./list.pug' lang='pug'></template>

<script>
import { Event } from 'vue-tables-2'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import LoadingPlaceholder from '../../../loading/LoadingPlaceholder'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { filterByAccessProfileName } from '../../../../utils/customFilters.js'
import customSorter from '../../../../utils/customSorter.js'
import { generateLoadingRows } from '../../../../utils/grid-load-transition.js'
import PerfilAcessoEnum from '../../../../enum/perfilAcessoEnum'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'AccessProfileList',

  components: {
    PageTitle,
    LoadingPlaceholder,
    ButtonPrimary
  },

  data () {
    return {
      isLoadingData: true,
      profiles: generateLoadingRows(10),
      columns: ['nome', 'visibilidade', 'acoes'],
      options: {
        templates: {
          nome: LoadingPlaceholder,
          visibilidade: LoadingPlaceholder,
          acoes: LoadingPlaceholder
        },
        columnsClasses: {
          'nome': 'col-md-6',
          'visibilidade': 'col-md-5',
          'acoes': 'col-md-1'
        },
        headings: {
          nome: this.$t('administracao.perfilAcesso.labels.perfil'),
          visibilidade: this.$t('administracao.perfilAcesso.labels.visibilidade'),
          acoes: this.$t('administracao.perfilAcesso.labels.acoes')
        },
        filterable: [],
        customFilters: [{
          name: 'nome',
          callback: filterByAccessProfileName
        }],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['nome'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        orderBy: {
          ascending: true,
          column: 'nome'
        },
        // Algoritmo customizado para ordenação alfabética ignorando caractéres especiais
        customSorting: {
          nome: function (ascending) {
            return function (a, b) {
              return customSorter.stringSorter(ascending, a, b, 'nome')
            }
          }
        }
      }
    }
  },

  methods: {
    handleFilter (event, column) {
      Event.$emit(`vue-tables.filter::${column}`, event.currentTarget.value)
    },

    isMasterProfile (accessProfileId) {
      return Number(accessProfileId) === PerfilAcessoEnum.MASTER
    },

    edit (acessProfileId) {
      trackAnalyticsEvent(this, 'edit-click', 'edit-perfil-de-acesso', 'edit-perfil-de-acesso')
      this.$store.dispatch('setProfileToEdit', acessProfileId).then((response) => {
        this.$router.push(PATHS.NEW_ACCESS_PROFILE)
      })
    },

    newProfile () {
      this.$router.push(PATHS.NEW_ACCESS_PROFILE)
    },

    loadProfiles () {
      this.$store.dispatch('getProfiles').then((response) => {
        this.profiles = response.data
        this.isLoadingData = false
        this.options.templates = {
          visibilidade: (h, row) => {
            return row.perfilAcessoBanking ? (
                row.perfilAcessoBanking.visibilidadeEstabelecimento === '0' ? this.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos') : this.$t('administracao.perfilAcesso.labels.visibilidadeAcessaAlguns')
              ) : this.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos')
          }
        }
      })
    },

    removeSpecialChars (newStringComAcento) {
      let string = newStringComAcento
      let mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB&(?!amp;)]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g,
        '-': /\s/g
      }

      mapaAcentosHex.forEach(letra => {
        let expressaoRegular = mapaAcentosHex[letra]
        string = string.replace(expressaoRegular, letra)
      })

      return string
    }
  },

  created () {
    this.loadProfiles()
  }
}
</script>



// WEBPACK FOOTER //
// List.vue?5ed9213d